import { render, staticRenderFns } from "./OlympicsStep3Modal.vue?vue&type=template&id=5ed6d170&scoped=true&"
import script from "./OlympicsStep3Modal.vue?vue&type=script&lang=js&"
export * from "./OlympicsStep3Modal.vue?vue&type=script&lang=js&"
import style0 from "./OlympicsStep3Modal.vue?vue&type=style&index=0&id=5ed6d170&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed6d170",
  null
  
)

export default component.exports